import React, {Component} from "react";
import CalendarPicker from './popup/Calendar'
// import * as R from 'ramda'
import M from 'moment'

class SimpleDate extends Component {
    constructor(props) {
        super(props);
        this.state = {
            date: props.date ? M(props.date, 'DD-MM-YYYY').toDate() : null,
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.date !== prevProps.date) {
            this.setState({
                date: this.props.date ? M(this.props.date, 'DD-MM-YYYY').toDate() : '',
            })
        }
    }

    render() {
        const {label, subLabel, mandatory, monthYear, errorMessage} = this.props
        const {date} = this.state
        return (
            <div className="margin-bottom-20px">
                <div className="margin-5px">
                    <div className="txt-site txt-11 txt-main txt-bold">
                        {label !== undefined && (
                            <h4>{label} {mandatory && <span style={{color: 'red'}}>*</span>}</h4>
                        )}
                    </div>
                    <div className="txt-site txt-11 txt-primary margin-5px">
                        {subLabel}
                    </div>
                </div>
                {monthYear ?
                    <input {...this.props} className="txt txt-sekunder-color" type="month"></input> :
                    <CalendarPicker
                        {...this.props}
                        date={date === 'invalid date' ? '' : date}
                    />
                }
                {mandatory && errorMessage && (
                    <p className="txt-site txt-11 color-red margin-top-5px">
                        {errorMessage}
                    </p>
                )}
            </div>
        )
    }
}

export default SimpleDate